import React, { useState, useEffect } from "react";
import styles from "./Assignments.module.css";
import Animation from "../Result/Animation/Animation";

const Assignments = () => {
  const [branch, setBranch] = useState("");
  const [sem, setSem] = useState("");
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowAnimation(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const fetchAssignments = async () => {
    if (!branch || !sem) {
      alert("Please select both Branch and Semester");
      return;
    }

    setLoading(true);
    setError(null);
    setAssignments([]);

    try {
      const resp = await fetch(
        `https://recstudentportal.com/ram/getAssignAPI.php?branch=${branch}&sem=${sem}`
      );

      if (!resp.ok) throw new Error("Failed to fetch assignments");

      const data = await resp.json();
      setAssignments(data);
    } catch (err) {
      console.error(err);
      setError("Failed to load assignments");
    }

    setLoading(false);
  };

  return (
    <>
      {showAnimation && (
        <div className={styles.animationScreen}>
          <Animation />
          <h3>Please Wait...</h3>
        </div>
      )}

      {!showAnimation && (
        <div className={styles.container}>
          <h1 className={styles.heading}>Assignments</h1>

          <div className={styles.formBox}>
            <select value={branch} onChange={(e) => setBranch(e.target.value)}>
              <option value="">Select Branch</option>
              <option value="cse">CSE</option>
              <option value="ece">ECE</option>
              <option value="ee">EE</option>
              <option value="me">ME</option>
              <option value="ce">CE</option>
            </select>

            <select value={sem} onChange={(e) => setSem(e.target.value)}>
              <option value="">Select Semester</option>
              <option value="1">Semester 1</option>
              <option value="2">Semester 2</option>
              <option value="3">Semester 3</option>
              <option value="4">Semester 4</option>
              <option value="5">Semester 5</option>
              <option value="6">Semester 6</option>
              <option value="7">Semester 7</option>
              <option value="8">Semester 8</option>
            </select>

            <button onClick={fetchAssignments}>Search</button>
          </div>

          {loading && <p className={styles.loading}>Loading...</p>}
          {error && <p className={styles.error}>{error}</p>}

          <div className={styles.resultBox}>
            {assignments.length === 0 && !loading && !error && (
              <p className={styles.noData}>No assignments available</p>
            )}

            {assignments.map((item, idx) => {
              const pdfURL = item.url;

              return (
                <div key={idx} className={styles.card}>
                  <h3>{item.title}</h3>
                  <p>File: {item.filename}</p>
                  <a href={pdfURL} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default Assignments;